<template>
    <div>
        <page-navigate></page-navigate>
        <div id="pageContainer">
            <section class="container1">
                <div class="flex contentBox justify-between ">
                    <div class="left">
                        <h1 class="super_large-72_bold md-title-32_bold word1">衍生品交易</h1>
                        <h2 class="subtitle-20_regular md-body-14_regular word2">
                            进入最大最具流动性的市场，交易全球热门货币对
                        </h2>
                        <a :href="signupUrl" target="_blank">
                            <div class="pageBtn primary-default_large">
                                <span class="word3">立即开户</span>
                                <span class="iconfont icon-right"></span>
                            </div>
                        </a>
                    </div>
                    <img class="right" src="@/assets/image/trading-product/tradingproductForex.png" alt="" />
                </div>
            </section>
            <product-tab></product-tab>
            <section class="container2">
                <div class="contentBox container2Content">
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up word4 scroll-fade-up">产品优势</h2>
                    <h3 class="text-center subtitle-20_regular md-footnote-regular_12 word5 scroll-fade-up">
                        衍生品差价合约具备高流动性、点差低、支持灵活杠杆与双向交易，是进行全球宏观交易和短线操作的理想选择
                    </h3>
                    <a href="https://edocs-1305385874.cos.ap-hongkong.myqcloud.com/web/EBC PRODUCT GUIDE_CN.pdf"
                        target="_blank">
                        <div class="primary-default_large jyBtn scroll-fade-up">交易产品指南</div>
                    </a>
                    <div class="topCardList flex scroll-fade-up">
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                fill="none">
                                <path d="M21.1546 31.4919V34.6666M12.8628 34.6666H29.8509" stroke="#9F734C"
                                    stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M12.3627 10.0793C10.9006 11.9442 10.0312 14.2796 10.0312 16.8142C10.0312 22.9201 15.0764 27.8699 21.2999 27.8699C27.5234 27.8699 32.5686 22.9201 32.5686 16.8142C32.5686 14.2796 31.6992 11.9442 30.2371 10.0793"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M12.584 5.49945C9.04174 8.10984 6.75049 12.2659 6.75049 16.947C6.75049 24.8491 13.2798 31.2551 21.3342 31.2551C29.3885 31.2551 35.9179 24.8491 35.9179 16.947C35.9179 12.2659 33.6266 8.10984 30.0844 5.49945"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M28.5995 16.3696C28.5995 16.3903 28.5995 16.412 28.5985 16.4329C24.9115 16.8881 21.9895 19.7548 21.5255 23.3722C21.5044 23.3731 21.4833 23.3731 21.4622 23.3731C21.4399 23.3731 21.4178 23.3731 21.3966 23.3722C20.9327 19.7547 18.0107 16.8881 14.3247 16.4329C14.3237 16.4122 14.3237 16.3905 14.3237 16.3696C14.3237 16.3489 14.3237 16.327 14.3247 16.3063C18.0107 15.8512 20.9327 12.9856 21.3966 9.36817C21.4178 9.36719 21.4399 9.36719 21.462 9.36719C21.4831 9.36719 21.5043 9.36719 21.5254 9.36817C21.9894 12.9855 24.9113 15.8512 28.5983 16.3063C28.5993 16.327 28.5995 16.3489 28.5995 16.3696Z"
                                    stroke="#A52933" stroke-width="1.25" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word6">超低点差</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word7">最低0点差即可交易</div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40"
                                fill="none">
                                <path
                                    d="M18.1204 28.0725C16.9544 28.6143 15.6571 28.9164 14.2902 28.9164C9.2133 28.9164 5.09766 24.7497 5.09766 19.6099C5.09766 14.4701 9.2133 10.3035 14.2902 10.3035C16.2075 10.3035 17.9878 10.8977 19.461 11.9143"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M17.2148 23.4897C16.4868 23.9797 15.6129 24.2652 14.6732 24.2652C12.1347 24.2652 10.0769 22.1819 10.0769 19.612C10.0769 17.0421 12.1347 14.9587 14.6732 14.9587C15.7601 14.9587 16.759 15.3407 17.5458 15.9793"
                                    stroke="#A52933" stroke-width="1.25" stroke-linecap="round" />
                                <path d="M13.1417 18.643H8.92847M13.1417 20.5818H8.92847" stroke="#A52933"
                                    stroke-width="1.25" stroke-linecap="round" />
                                <path d="M11.8005 8.36636C14.6732 5.58735 22.1804 1.69674 29.2281 8.36636"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <path d="M29.2283 31.6333C26.3556 34.4123 18.8484 38.303 11.8007 31.6333"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M30.942 28.4791C29.5836 29.2532 28.0156 29.6948 26.3457 29.6948C21.1631 29.6948 16.9617 25.4413 16.9617 20.1944C16.9617 14.9475 21.1631 10.6941 26.3457 10.6941C31.5284 10.6941 35.7298 14.9475 35.7298 20.1944C35.7298 21.3475 35.5269 22.4526 35.1552 23.4751M33.0486 26.8433C33.5206 26.3556 33.9412 25.8167 34.3013 25.2354"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M29.7933 16.8971H25.4099C24.4462 16.8971 23.665 17.6783 23.665 18.642V18.642C23.665 19.6057 24.4462 20.387 25.4099 20.387H27.3769C28.3942 20.387 29.2188 21.2116 29.2188 22.2289V22.2289C29.2188 23.2461 28.3941 24.0708 27.3769 24.0708H22.8989M26.3461 14.1827V26.2035"
                                    stroke="#A52933" stroke-width="1.25" stroke-linecap="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word8">37 种货币对</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word9">
                                包含所有主流货币对、交叉货币对和非主流货币对
                            </div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                                fill="none">
                                <path d="M22.357 21.9232V16.4488M5.21411 5.5H13.357M5.21411 9.44157H9.28554"
                                    stroke="#A52933" stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M13.3933 24.7699C13.2296 24.0672 13.1429 23.334 13.1429 22.5801C13.1429 17.3798 17.2682 13.1642 22.3571 13.1642C27.446 13.1642 31.5714 17.3798 31.5714 22.5801C31.5714 27.7804 27.446 31.9961 22.3571 31.9961H9.71428M19.7857 28.4925H5M22.3571 35.4997H14.4286M13.3933 13.1642L11.8571 12.0693M31.5714 13.1642L33.0714 11.6313M19.7857 9.87952V5.5H25.1429V9.87952M18.2857 5.5H26.8571"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <path
                                    d="M22.357 35.5001C29.3394 35.5001 34.9998 29.7158 34.9998 22.5805C34.9998 15.4452 29.3394 9.66089 22.357 9.66089C15.3745 9.66089 9.71411 15.4452 9.71411 22.5805C9.71411 23.4809 9.80424 24.3597 9.97579 25.2082"
                                    stroke="#9F734C" stroke-width="1.25" stroke-linecap="round" />
                                <ellipse cx="22.4323" cy="23.314" rx="1.21622" ry="1.24284" stroke="#A52933"
                                    stroke-width="1.25" stroke-linecap="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word10">极致的交易速度</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word11">平均执行速度20ms</div>
                        </div>
                        <div class="card">
                            <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40"
                                fill="none">
                                <path d="M32.4026 30.9487H8.51416V34.7402H32.4026V30.9487Z" stroke="#9F734C"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M16.411 10.0127L8.51416 12.3469L10.1795 11.8555L18.8988 9.30627"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M32.4026 5.25916L24.5945 7.56609L23.4478 7.90394L30.8225 5.72669L30.6621 5.80176L21.9429 8.351"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M20.4587 10.0638V30.9491" stroke="#9F734C" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path
                                    d="M20.4655 10.0637C21.1761 10.0637 21.7521 9.48771 21.7521 8.77716C21.7521 8.06661 21.1761 7.4906 20.4655 7.4906C19.755 7.4906 19.179 8.06661 19.179 8.77716C19.179 9.48771 19.755 10.0637 20.4655 10.0637Z"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.3912 19.5002C12.3468 21.6058 10.6269 23.2882 8.51444 23.2882C6.40202 23.2882 4.67523 21.6058 4.63428 19.4968"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M12.4009 19.4965C10.2544 19.4965 8.51052 17.7561 8.51052 15.6061C8.51052 17.7527 6.77007 19.4965 4.62012 19.4965"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.2794 12.6749C36.235 14.7805 34.515 16.4629 32.4026 16.4629C30.2902 16.4629 28.5668 14.7771 28.5259 12.6715"
                                    stroke="#A52933" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M36.2896 12.6745C34.143 12.6745 32.3992 10.934 32.3992 8.78406C32.3992 10.9306 30.6587 12.6745 28.5088 12.6745"
                                    stroke="#9F734C" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <h3 class="title-24_medium md-body-16_medium word12">灵活的杠杆</h3>
                            <div class="desc content-16_regular md-footnote-regular_12 word13">杠杆高达500:1</div>
                        </div>
                    </div>
                    <h2 class="text-center title-48_bold md-title-24_bold scroll-fade-up">市场报价</h2>
                    <div id="pageOverLay"></div>
                    <product-module-new />
                </div>
            </section>
            <open-account></open-account>
            <section class="container4 commonQuestion">
                <div class="contentBox">
                    <h2 class="scroll-fade-up">常见问题</h2>
                    <div class="QA-list">
                        <div class="QA-item">
                            <div class="QA-title">1.什么是衍生品交易 </div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    就是将一种货币兑换成另一种货币。当衍生品市场出现波动时，交易者可以通过货币之间的价差赚取收益。
                                </p>
                                <p class="QA-li">
                                    货币的波动取决于诸多因素，如政治、战争、灾难、瘟疫、全球经济、货币政策、利率和通货膨胀等，从而对货币的需求和供应产生影响，并引起汇率波动。
                                </p>
                                <p class="QA-li">
                                    作为全球交易量极为庞大的市场，衍生品市场的日均交易量达7.5万亿美元，这意味着没有任何机构和个人可以操纵衍生品市场，并提供了随时随地参与交易的方式。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">2.衍生品可以交易什么？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    衍生品市场包括市场上各大主流货币对。其中，EURUSD、GBPUSD、USDJPY、USDCAD、USDCHF、AUDUSD、NZDUSD是全世界主要的七大交易货币对。
                                </p>
                                <p class="QA-li">
                                    当进行衍生品交易时，这些货币对的订单会被抛到由银行、非银机构组成的银行间市场中。一般来说，我们会发现货币对“买入”和“卖出”价格之间存在着差异，这就是“点差”，它取决于银行和非银机构所能提供的流动性。
                                </p>
                                <p class="QA-li">
                                    通常来说，市场的流动性越强，订单就越容易成交，报价也就更优。
                                </p>
                                <p class="QA-li">
                                    EBC为交易者提供37种货币对，最低0点差即可交易。通过EBC构筑的机构级清算池参与衍生品交易，可以直连25+顶级机构组成的银行间市场，享受机构级的订单深度和极具竞争力的交易成本。
                                </p>
                            </div>
                        </div>

                        <div class="QA-item">
                            <div class="QA-title">3.衍生品交易的时段？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    有别于股票及商品设有中央交易所，买卖双方可以透过这里进行交易，货币对交易是在全球多家银行、经纪商的多重网络上进行，于是它并不局限于任何交易时段安排，从而让交易者以更灵活的时间，让交易者有机会进行每星期5日、每日24小时的交易。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">4.衍生品交易的杠杆</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    衍生品交易的杠杆决定了你的资金利用率。通常来说，杠杆越高，资金利用率越高。
                                </p>
                                <p class="QA-li">比如，一标准手EURUSD合约的价值是100000美元。</p>
                                <p class="QA-li">
                                    如果没有杠杆，需要全额支付100000美元，那么占用的资金就是100000美元；
                                </p>
                                <p class="QA-li">
                                    如果是500倍杠杆，只需要占用200美元，相当于资金利用率提高了500倍；
                                </p>
                                <p class="QA-li">
                                    如果是100倍杠杆需要1000美元、200倍杠杆需要500美元；
                                </p>
                                <p class="QA-li">
                                    但是杠杆越高，也意味着损失也可能会被相应的放大。
                                </p>
                                <p class="QA-li">
                                    我们建议，在交易时严格将仓位控制在3-5成，比如您的账户资金是1000美元，确保您的占用资金在300-500美元，剩余的资金将作为风险缓冲应对行情波动风险；如果您是初学者，我们建议您将仓位控制在1-3成。
                                </p>
                                <p class="QA-li">
                                    目前，基于风险和收益平衡的考量以及MiFID
                                    II监管框架下要求，EBC提供最高500倍杠杆。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">5.衍生品交易中的点值是什么？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    衍生品交易中的点值，是衍生品波动中的最小价格变动。通常我们会说“波动了多少个点”，对应的就是多少点值。
                                </p>
                                <p class="QA-li">
                                    绝大部分的货币对的点值对应的是报价小数点后四位，也就是0.0001，比如EURUSD从1.0558波动至1.0559，我们就说EURUSD波动了一个点，通常这一类货币对一标准手合约每波动1个点，账户浮盈10美元；
                                </p>
                                <p class="QA-li">
                                    少部分货币对的点值对应的是报价小数点后两位，比如USDJPY从149.01波动至149.02，我们就说USDJPY波动了一个点。
                                </p>
                            </div>
                        </div>
                        <div class="QA-item">
                            <div class="QA-title">6.如何学习参与衍生品交易？</div>
                            <div class="QA-content">
                                <p class="QA-li">
                                    衍生品交易，是同时买入一对货币组合中的一种货币而卖出另外一种货币。比如EUR/USD，就代表买入欧元，卖出美元；与之相对应的是，USD/JPY就是买入美元，卖出日元。
                                </p>
                                <p class="QA-li">
                                    它本质是通过两种货币的强弱关系赚取差价。一般来说，我们会买入一组货币对中走强的货币，卖出走弱的货币。
                                </p>
                                <p class="QA-li">
                                    比如，您看多欧元、看空美元，那么就可以买入EURUSD；但如果您看多美元，看空欧元，那么就可以卖出EURUSD。
                                </p>
                                <p class="QA-li">
                                    一组货币的强弱取决于很多的因素，比如一国央行的货币政策，一国的经济数据和通胀水平等等。一般来说，当央行趋向于加息，货币供应收紧，对应的货币会走强；如果一国经济数据表现良好，市场通常会预期通胀上升和央行加息，从而带动货币走高。
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
        <message-v3></message-v3>
        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import {
    mapGetters,
} from 'vuex'
export default {
    mixins: [fadeAnimate],
    data() {
        return {
            infoData: "",
            newData: "",
            pagIndex: 0,
            num: 3,
            newsdisplay: "none"
        }
    },
    computed: {
        ...mapGetters([
            'signupUrl',
        ]),
    },
    destroyed() {
    },

    mounted() {
        this.initPage()
    },
    methods: {
        initPage() {
            const setTabActIdx = (idx, e) => {
                scrollTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement.forEach((item, index) => {
                    item.classList.remove("active");
                });
                floatTabElement[idx].classList.add("active");
                scrollTabElement[idx].classList.add("active");
                const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
                const leftPad = 32 * rem;
                const wrapper = document.querySelector(".scrollTabWrapper");
                wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
            };
            const scrollTabElement = document.querySelectorAll(
                ".scrollTabWrapper .tabItem"
            );
            const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
            floatTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            scrollTabElement.forEach((item, idx) => {
                item.addEventListener("click", function (e) {
                    jumpPage(idx);
                });
            });
            let tabIndex = 0;

            if (location.href.includes("/commodity/")) {
                tabIndex = 1;
            } else if (location.href.includes("/index-cfds/")) {
                tabIndex = 2;
            } else if (location.href.includes("/share-cfds/")) {
                tabIndex = 3;
            } else if (location.href.includes("/etf/")) {
                tabIndex = 4;
            } else if (location.href.includes("/crypto/")) {
                tabIndex = 5;
            }
            setTabActIdx(tabIndex, { target: floatTabElement[tabIndex] });
            setTabActIdx(tabIndex, { target: scrollTabElement[tabIndex] });
            function jumpPage(idx) {
                const pathArr = location.pathname.split("/");
                const len = pathArr.length;
                const targetArr = ["forex", "commodity", "index-cfds", "share-cfds", "etf", 'crypto'];
                pathArr[len - 2] = targetArr[idx];
                location.href = pathArr.join("/");
            }
            ProductVM.changeHandle(tabIndex);
            document.addEventListener("mountedSuccess", (e) => {
                ProductVM.changeHandle(tabIndex);
            });


        }
    }
}

</script>
<style scoped lang="scss">
@import url("../assets/css/commonQuestion.scss");

* {
    font-family: Inter, Noto Sans Sc, sans-serif;
}

.message-new .gender-btn::before {
    box-sizing: border-box;
}

.message-new {
    max-width: 1200rem;
    padding-inline: calc((100vw - 1200rem) / 2) !important;
    box-sizing: content-box;
}

.message-new .p1 {
    font-size: 48rem !important;
    line-height: 56rem !important;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

body.no-scroll {
    overflow: hidden;
}

#pageOverLay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    display: none;
    opacity: 0;
    transition: opacity 0.6s ease;
}

.pageContainer {
    position: relative;
}

#pageContainer {
    background: var(--ebc-neutral-bg_a)
}

#pageContainer .pageBtn {
    gap: 4rem;
    min-width: 180rem;
    width: fit-content;
    cursor: pointer;
}

#pageContainer a {
    width: fit-content;
    display: block;
    margin-inline: auto;
}

.container1 {
    padding-top: calc(80px + 15rem);
    height: 560rem;
    background: var(--ebc-neutral-bg_c);
}

.container1 .left {
    flex: 0 0 770rem;
}

.container1 .left h2 {
    margin: 24rem 0 64rem;
    color: var(--ebc-text-secondary);
}


.container1 .right {
    height: 412rem;
}

.container1 a {
    margin: 0 !important;
}

@media (max-width: 996px) {
    html {
        overflow-x: hidden;
    }

    body {
        overflow-x: visible !important;
    }

    .message-new .p1 {
        font-size: 48rem !important;
        line-height: 72rem !important;
    }

    .container1 {
        padding: 80rem 32rem;
        height: auto;
        overflow-x: hidden;
    }

    .container1 .right {
        /* width: 586rem; */
        height: 586rem;
        margin: 0 auto 80rem;
    }

    .container1>div {
        flex-direction: column;
    }

    .container1 .left {
        order: 2;
        text-align: center;
        flex: 1;
    }

    .container1 .left h2 {
        margin-top: 16rem;
    }

    #pageContainer .container1 a {
        width: 100%;
    }

    #pageContainer .container1 .left .pageBtn {
        width: 100%;
    }

}


.container2 {
    background: var(--ebc-neutral-bg_a);
    margin-top: -64rem;
}

.pt .floatTab,
.es .floatTab {
    width: 900rem;
}

.floatTab {
    position: sticky;
    transform: translateY(-50%);
    z-index: 98;
    top: 128px;
    margin-inline: auto;
    background: var(--ebc-basecolor-white-85);
    border-radius: var(--ebc-corner-radius-full);
    box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
    backdrop-filter: blur(10px);
    padding: 4rem;
    gap: 8rem;
    width: 792rem;
    height: 64rem;
}

.floatTab .tabItem {
    flex: 1;
    color: var(--ebc-text-secondary);
}

.floatTab .active {
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_c);
    color: var(--ebc-text-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-weight: 500;
}

.container2 .container2Content {
    padding: 120rem 0;
}

/* .container2 .container2Content>a:last-of-type{
  display:none!important
} */

.container2 h2 {
    margin-bottom: 16rem;
}

.tradingProductPage .container2 h2 {
    max-width: 850rem;
    margin-inline: auto;
}

.container2 h3 {
    max-width: 850rem;
    margin-inline: auto !important;
}

.container2 h3 {
    margin: 16rem 0;
    color: var(--ebc-text-secondary);
}

.container2 .pageBtn {
    margin: 60rem auto 0;
}

@media (max-width: 996px) {
    html {
        height: auto !important;
        min-height: auto !important;
    }

    .container2 {
        padding: 0 32rem;
        margin-top: 0;
    }

    .container2 .container2Content .btnTop {
        height: 64rem;
        font-size: 28rem;
        gap: 8rem;
        line-height: 44rem;
    }

    .container2 .pageBtn {
        height: 80rem;
        font-size: 28rem;
        line-height: 44rem;
        margin-top: 80rem;
    }

    .floatTab {
        display: none !important;
    }

    .container2 .container2Content {
        padding: 64rem 0 160rem;
    }

    .container2 h3 {
        margin: 16rem 0;
    }

    .scrollTab {
        display: inline-flex;
        gap: 16rem;
        min-width: fit-content;
    }

    .scrollTabWrapper {
        overflow-x: auto;
        scroll-behavior: smooth;
        padding: 16rem 32rem;
        margin-top: 64rem;
        background: var(--ebc-neutral-bg_a);
        position: sticky;
        top: 44px;
        z-index: 99
    }

    .scrollTabWrapper::-webkit-scrollbar {
        display: none;
    }

    .scrollTab .tabItem {
        color: var(--ebc-text-secondary);
        padding: 16rem 32rem;
        flex: 1;
        background: var(--ebc-neutral-bg_b);
        border-radius: var(--ebc-corner-radius-full);
        white-space: nowrap;
    }

    .scrollTab .active {
        background: var(--ebc-basecolor-active-500);
        color: var(--ebc-text-primary_white);
        font-weight: 500;
    }
}




.container1 {
    padding-top: calc(141rem)
}

.container1 .contentBox {
    gap: 20rem;
    align-items: flex-start;
}

.container1 .left {
    flex: 0 0 588rem;
    padding-top: 19rem;
}

.container1 .right {
    height: 288rem;
}

@media (min-width: 996px) {
    .vi .container1 h1 {
        white-space: nowrap;
    }

    .mn .container1 h1 {
        font-size: 60rem;
        white-space: nowrap;
        line-height: 68rem;
    }
}

@media (max-width: 996px) {
    .container1 {
        padding-top: 80rem;
    }

    .container1 .contentBox {
        gap: 0rem;
    }

    .container1 .left {
        padding: 0;
        flex: 1;
        width: 100%;
    }

    .container1 .right {
        height: 270rem;
        margin-bottom: 80rem;
    }

    .container1 .left h2 {
        margin: 16rem 0 64rem;
    }
}

.container2 h3 {
    margin: 16rem 0 60rem;
}

.container2 .contentBox {
    padding-top: 88rem;
}

.container2 .topCardList {
    margin-bottom: 120rem;
    gap: 24rem;
    align-items: stretch;
}

.container2 .topCardList .card {
    flex: 1;
    border-radius: var(--ebc-corner-radius-rc16);
    background: var(--ebc-neutral-bg_b);
    padding: 32rem 24rem;
    border: 0;
}

.container2 .topCardList .card h3 {
    margin: 16rem 0;
    color: var(--ebc-text-primary);
    width: 100%;
}

.container2 .topCardList .card div {
    color: var(--ebc-text-secondary);
}

.container2 .jyBtn {
    margin-bottom: 60rem;
    min-width: 180rem;
}

@media (max-width: 996px) {
    .container2 .jyBtn {
        height: 80rem;
        margin-bottom: 80rem;
        min-width: unset;
        font-size: 28rem;
        line-height: 44rem;
        font-weight: 500;
    }

    .container2 .topCardList {
        margin-bottom: 160rem;
    }

    .container2 h3 {
        margin-bottom: 80rem;
    }

    .container2 .topCardList {
        margin-bottom: 160rem;

        gap: 32rem;
        flex-wrap: wrap;
    }

    .container2 .topCardList .card h3 {
        margin: 32rem 0 16rem;
        color: var(--ebc-text-primary);
    }

    .container2 .topCardList .card {
        padding: 32rem;
        flex: 0 0 calc(50% - 16rem);
    }
}
</style>